export type VenueSearchResult = {
  id: string;
  name: string;
  address: string | null;
  cover_url: string | null;
};

type SearchResponse = {
  groups: {
    venues: {
      count: number;
      items: VenueSearchResult[];
    };
  };
};

export async function searchVenues(query: string, signal?: AbortSignal): Promise<VenueSearchResult[]> {
  const params = new URLSearchParams({
    q: query,
    limit_per_group: '10',
  });

  const response = await fetch(`/api/v1/search?${params.toString()}`, {
    signal,
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Search request failed with ${response.status}`);
  }

  const payload = await response.json() as SearchResponse;
  return payload.groups.venues.items;
}
